import { VariantClassesProps } from '../../utils'
import { Size } from './Avatar.types'

export const getAvatarSize = (size: Size) => {
    const sizes: VariantClassesProps = {
        sm: 'h-8 w-8',
        default: 'h-9 w-9',
        normal: 'h-10 w-10',
        base: 'h-32 w-32',
        md: 'h-40 w-40',
        lg: 'h-40 w-40',
        xl: 'h-avatar-lg w-avatar-lg',
    }

    return sizes[size]
}

export const getTextClasses = () => {
    return 'text-center font-sans font-black leading-tight text-blue-950'
}

export const getAvatarClasses = () => {
    return 'inline-flex flex-col items-center justify-center rounded-full bg-gray-300 bg-cover'
}
